import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    this.galleries = [
      [
        {src: this.prefixPath('landing-desktop.jpg'), caption: 'Landing page'},
        {src: this.prefixPath('search-result-desktop.jpg'), caption: 'Problem set searching'},
        {src: this.prefixPath('test-result-desktop.jpg'), caption: 'Exam simulation mode'},
        {src: this.prefixPath('test-taking-choice-desktop.jpg'), caption: 'Diagnosis report'},
      ]
    ];

    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >
          <div className="section">
            <div className="section-header">
              <PortfolioNextPrevLink data={data} />
              <h2>Description</h2>
            </div>
            <p>
              UCheckPoint is an online university admission examination simulation for Thai students. 
              It aims to help students tackle the incredibly steep learning curve of examination preparation. 
              Instead of providing the same problem set for all students, 
              UCheckPoint utilizes machine learning to continually suggests tractable practice question according to the skill level of the student. 
              At the end of each simulated session, the test taker receives a recommendation report pointing out the areas to improve.
            </p>
            <br />
            <p>
              In this project, I designed the front-end web experience targeted at Thai test takers and the backend collaboration system for quiz content editors. 
              Additionally, I have created the flat-styled illustrations used on the website.
            </p>
          </div>

          <div className="section">
            <div className="center">
            Key Mockup Frames
            </div>
          </div>

          <div className="section">
            <Gallery images={this.galleries[0]} />
          </div>
          {/*
          <div className="section-header">
            <h2>Intro</h2>
          </div>
          <p>
            UCheckPoint aims to make university admission exam a painless experience for Thai highscool students. 
            They plan to create a machine learning powered test simulator in which questions are adaptive according to 
            student skill levels. 
          </p>  

          <br /><br />
          <div className="section-header">
            <h2>Execution</h2>
          </div>

          <h3>Frontend design</h3>
          <p>
            test 
          </p>



          <br/>
          <h3>Backend design</h3>
          <p>
            The first iteration of RESUS Ultrasound was made with one chapter to conduct user tests with several doctors and medical students. 
            Here's the marvel interactive prototype.
          </p>

          <br />
          <div className="section-header">
            <h2>Outcome</h2>
          </div>

          <p>

          </p>

          */}

          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Sarawoot Piya-arayanunt (Full Stack Developer)</li>
              <li>Soravis Prakkamakul (UX/UI Designer)</li>
            </ul>
          </div>

          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/ucheckpoint/index.jsx
 **/